<template>
    <div>
        <van-nav-bar :title="rank.title" left-arrow @click-left="$router.go(-1)" />

        <middle-loading :loading="loading" v-if="loading" />
        <template v-else>
            <div class="userRank" v-for="item in userPaperList" :key="item.id">
                <div>
                    <span>第 {{ item.rank }} 名</span>
                    <van-image round width="1.5rem" height="1.5rem" :src="item.user.avatar" />
                    <span>{{ item.user.nickname }}</span>
                </div>
                <div>
                    <span class="time">{{ secondsToHms(item.duration_seconds) }}</span>
                    <span class="correct">{{ item.correct_count }}</span>
                </div>
            </div>

            <table class="table">
                <thead>
                    <tr>
                        <th class="id">排名</th>
                        <th class="user">用户ID</th>
                        <th class="time">用时</th>
                        <th class="correct">答对</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in rank.user_papers" :key="item.id">
                        <td class="id">{{ (index + 1).toString().padStart(2, '0') }}</td>
                        <td class="user">
                            <van-image round width="1.5rem" height="1.5rem" :src="item.user.avatar" />
                            {{ item.user.nickname }}
                        </td>
                        <td class="time">{{ secondsToHms(item.duration_seconds) }}</td>
                        <td class="correct">{{ item.correct_count }}</td>
                    </tr>
                </tbody>
            </table>
        </template>
    </div>
</template>

<script>
import MiddleLoading from '@/components/MiddleLoading'
import { secondsToHms } from '@/utils/util'
import { LOGIN_USER } from '@/utils/constants'
import { getPaperPeriodDetail, getUserPaperList } from '@/api/paper_period'

export default {
    name: 'PaperPeriodRank',
    components: { MiddleLoading },
    data() {
        return {
            loading: true,
            rank: {},
            columns: [
                { title: '排名', field: 'id' },
                { title: '用户ID', field: 'nickname' },
                { title: '用时', field: 'duration_seconds' },
                { title: '答对', field: 'correct_count' },
            ],
            userPaperList: [],
        }
    },
    created() {
        getUserPaperList().then((res) => {
            this.userPaperList = res.data
        })
        getPaperPeriodDetail(this.$route.query.id).then((res) => {
            this.rank = res.data
            this.userPaperList = this.rank.user_papers.filter((item, index) => {
                item.rank = index + 1
                return item.user?.id === this.$ls.get(LOGIN_USER).id
            })
            this.rank.user_papers = res.data.user_papers.splice(0, 100) // 只显示前100名
            this.loading = false
        })
    },
    methods: {
        secondsToHms,
    },
}
</script>

<style lang="less" scoped>
.userRank {
    margin: 15px;
    padding: 30px 20px;
    background: @blue-bg;
    border-radius: @large-border-radius;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: @large-font-size;
    color: @orange;

    .van-image {
        vertical-align: middle;
        margin: 0 5px;
    }

    .correct,
    .time {
        margin-left: 20px;
    }
}

.table {
    width: calc(100% - 30px);
    overflow-y: auto;
    background: white;
    margin: 15px;
    padding: 15px 5px;
    border-radius: @large-border-radius;
    text-align: center;
    table-layout: fixed;

    thead {
        display: table;
        width: 100%;

        th {
            color: @grey;
        }
    }

    .user {
        text-align: left;
        width: 250px;
    }

    .id,
    .correct,
    .time {
        width: 40px;
    }
}

tbody {
    display: block;
    height: 500px;
    overflow-y: scroll;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }

    tr {
        height: 45px;
    }

    .van-image {
        vertical-align: middle;
        margin-right: 5px;
    }

    .id {
        color: @grey;
    }
}
</style>
